import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { ManagementContainerTypeModel, ManagementUpdateContainerTypeModel } from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class ContainerTypesRepository {
  constructor(private apiService: ApiService) {}

  public search(params?: PaginationSearchModel, isShowLoader?: boolean): Observable<PaginatedResultModel<ManagementContainerTypeModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementContainerTypeModel>>(
      environment.url.freight.containerTypesManagement,
      { params },
      { isShowLoader },
    );
  }

  public create(model: ManagementUpdateContainerTypeModel, isShowLoader?: boolean): Observable<ManagementContainerTypeModel> {
    return this.apiService.post<ManagementContainerTypeModel>(`${environment.url.freight.containerTypesManagement}`, model, null, {
      isShowLoader,
    });
  }

  public get(id: ManagementContainerTypeModel['id'], isShowLoader?: boolean): Observable<ManagementContainerTypeModel> {
    return this.apiService.get<ManagementContainerTypeModel>(`${environment.url.freight.containerTypesManagement}/${id}`, null, {
      isShowLoader,
    });
  }

  public update(
    id: ManagementContainerTypeModel['id'],
    model: ManagementUpdateContainerTypeModel,
    isShowLoader?: boolean,
  ): Observable<ManagementContainerTypeModel> {
    return this.apiService.put<ManagementContainerTypeModel>(`${environment.url.freight.containerTypesManagement}/${id}`, model, null, {
      isShowLoader,
    });
  }

  public delete(id: ManagementContainerTypeModel['id'], isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete(`${environment.url.freight.containerTypesManagement}/${id}`, null, { isShowLoader });
  }
}
